import { createFileRoute, Navigate } from "@tanstack/react-router";

/** Saved draft links open the worlds being built in Simulation's Worlds list. */
export const Route = createFileRoute(
  "/_console/p/$org/$project/simulate/drafts/",
)({
  component: MovedDraftsRoute,
});

function MovedDraftsRoute() {
  return (
    <Navigate
      to="/p/$org/$project/simulate"
      params={Route.useParams()}
      search={{ kind: "building" }}
      replace
    />
  );
}
